// extracted by mini-css-extract-plugin
module.exports = {"quote-text":"style_quote-text__2tcex","image-container":"style_image-container__Xh7Ke"};